import { useEffect } from "react";
import { Form } from "antd";
import { FormInstance } from "antd/lib/form";
import { isString, mapValues, trim } from "lodash";

type FormValuesPatch<Values> = Parameters<FormInstance<Values>["setFieldsValue"]>[0];

export function trimValues<T extends object>(values: T): T {
  return mapValues(values, (value) => (isString(value) ? trim(value) : value)) as T;
}

export function useAssetFormModal<Values, Item>(
  visible: boolean,
  item: Item | undefined,
  toFormValues: (item?: Item) => FormValuesPatch<Values>
) {
  const [form] = Form.useForm<Values>();

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      return;
    }
    form.setFieldsValue(toFormValues(item));
  }, [form, item, toFormValues, visible]);

  return form;
}
